import React from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { decodeEntities, htmlToReactEl } from "./utils";
import { sendChatMessage } from "../../../../helpers/mqttService";
import TextMessage from "../TextMessage";
import HTMLReactParser from "html-react-parser";
import { TextWrapper } from "..";
import _ from "lodash";

type Props = {
  assignChatId: string
  msg: any
  fromId: string
  fromName: string;
  mId: string;
  isPrivate: boolean
  logs: any[]
}

export function CardChoice(props: Props) {
  const activeRootTab = useSelector((state: any) => state.ui.activeRootTab)
  const { msg, logs, assignChatId, isPrivate } = props;
  const isUser = props.fromId.includes("u/");
  const lastMsg = logs[logs.length - 1]

  const shouldShowActions =
    lastMsg && lastMsg.msgType === "cardChoice" && (props.mId === lastMsg.mId) && activeRootTab === 'live';

  const handleOptionSelect = (label: string, description: string, id: any) => {
    sendChatMessage({
      isPrivate,
      chatId: assignChatId,
      msgType: "cardChoiceResponse",
      msg: {
        label,
        description,
        id,
      },
    })
  };

  const containerStyle: React.CSSProperties = {
    width: "350px",
    backgroundColor: "#ffffff",
    color: "#6b6b6b",
    borderRadius: "4px 14px 0px 4px",
  };

  const cardTitleStyle: React.CSSProperties = {
    fontSize: "16px",
    fontWeight: 600,
    marginBottom: "8px",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    color: "#6b6b6b",
  };
  const cardListStyle: React.CSSProperties = {
    paddingLeft: 0,
    justifyContent: "center",
    alignItems: "center",
    listStyleType: "none",
    display: "grid",
    gridGap: "1rem",
    gridTemplateColumns: msg.style.orientation === "H" ? 'repeat(2,1fr)' : 'repeat(1,1fr)',
    gridAutoFlow: "unset"
  };
  const cardOptionStyle: React.CSSProperties = {
    display: "flex",
    wordBreak: "break-all",
    justifyContent: "start",
    alignItems: "center",
    width: "100%",
    padding: "5px 20px",
    cursor: "pointer",
    textAlign: "left",
    color: "#555555",
    borderRadius: "15px",
    boxShadow: "0px 2px 5px 0px rgb(226 226 226)",
    border: "1px solid rgb(232, 233, 241)",
    background: "#ffffff",
    fontSize: "10px",
    fontWeight: 500,
    height: "100%",
  };
  const optionHover = (liOption: HTMLLIElement, isFlag: boolean) => {
    if (shouldShowActions && liOption) {
      liOption.style.background = isFlag
        ? "#f0f0f0"
        : "#ffffff";
      liOption.style.color = isFlag
        ? "#2d2d2d"
        : "#000000";
    }
  };
  const cardOptionValueStyle: React.CSSProperties = {
    display: "block",
  };
  const optionLabelStyle: React.CSSProperties = {
    wordBreak: "break-word"
  };
  const liOptions = React.useRef<HTMLLIElement[]>([]);

  if (!shouldShowActions) {
    const cardChoiceTitle = msg.text ? msg.text : msg.title
    return (
      <TextWrapper>
        <TextMessage
          isUser={!isUser}
          fontSize="16px"
          color="#212332"
          backgroundColor={isUser ? "#e8e9f1" : "#FBEBE3"}
          message={HTMLReactParser(decodeEntities(cardChoiceTitle))}
        />
      </TextWrapper>
    )
  }

  return (
    <div style={{ display: "flex", flexDirection: "row-reverse" }}>
    <div style={containerStyle}>
      <Outline
        theme={{
          outlineColor: "#ff6c06",
          shouldShowActions,
        }}
        style={{
            borderRadius: "4px 14px 0px 4px"
        }}
      >
        <div style={cardTitleStyle}>
          {htmlToReactEl(msg.title)}
        </div>
        <ul style={cardListStyle}>
          {msg.choices.map((choice, index) => {
            const description = choice.description ? choice.description : choice.subText as string
            return (
              <li
                style={cardOptionStyle}
                key={choice.id}
                ref={(el) => {
                  if (liOptions.current && el) {
                    liOptions.current[index] = el
                  }
                }}
                onMouseEnter={() =>
                  optionHover(liOptions.current[index], true)
                }
                onMouseLeave={() =>
                  optionHover(liOptions.current[index], false)
                }
                onClick={() =>
                  handleOptionSelect(
                    choice.label,
                    description,
                    choice.id
                  )
                }
              >
                <span className="option">
                  <span
                    title={decodeEntities(choice.label)}
                  >
                    <div style={optionLabelStyle}>
                      {htmlToReactEl(choice.label)}
                    </div>
                  </span>
                  <span style={cardOptionValueStyle}>
                    {htmlToReactEl(description)}
                  </span>
                </span>
              </li>
            );
          })}
        </ul>
      </Outline>
    </div>
    </div>
  );
};


const Outline = styled.div`
  padding: 16px;
  width: 100%;
  height: 100%;
  padding: 10px;
  border-width: 1px;
  border-style: solid;
  border-color:#e8e9f1;
}
`;
